import { throttle } from "lodash";

ko.bindingHandlers.ckeditor = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        const minHeight = ko.unwrap(allBindingsAccessor.get('minHeight'));

        let editorRef = {
            current: null
        }

        ClassicEditor
            .create(element, {
                viewportTopOffset: '50px',
                toolbar: [
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    '|',
                    'link',
                    'bulletedList',
                    'numberedList',
                    'alignment',
                    '|',
                    'imageInsert',
                    'blockQuote',
                    'insertTable',
                    'mediaEmbed',
                    '|',
                    'horizontalLine',
                    'fontColor',
                    '|',
                    'code',
                    'codeBlock',
                    '|',
                    'removeFormat',
                    'sourceEditing',
                    '|',
                    'findAndReplace'
                ],
                mediaEmbed: {
                    previewsInData: true,
                    extraProviders: [
                        {
                            name: 'loom',
                            //url: /^loom\.com\/share\/(\w+)/,
                            url: /^loom\.com\/share\/(\w+)[a-zA-Z0-9\/-]*(\?+.*)*/, // to be able to parse params
                            //html: match => `<div style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="https://www.loom.com/embed/${match[1]}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>`
                            html: match => `<div style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="https://www.loom.com/embed/${match[1]}${match[2] || ''}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>`
                        }
                    ]
                },
                image: {
                    toolbar: [
                        'imageTextAlternative',
                        'imageStyle:inline',
                        'imageStyle:block',
                        'imageStyle:side',
                        'linkImage'
                    ]
                },
                table: {
                    contentToolbar: [
                        'tableColumn',
                        'tableRow',
                        'mergeTableCells',
                        'tableCellProperties',
                        'tableProperties'
                    ]
                },
                removePlugins: ["MediaEmbedToolbar"], // console warning message fix, shouldnt affect anything
                extraPlugins: [MyCustomUploadAdapterPlugin],
                language: {
                    ui: 'en',
                    content: 'en'
                }
            })
            .then(editor => {
                editorRef.current = editor;
                editor.ui.view.stickyPanel.unbind('isActive');
                editor.ui.view.stickyPanel.isActive = false;

                editorRef.current.setData(ko.unwrap(valueAccessor()));

                editor.model.document.on('change:data', throttle(() => {
                    valueAccessor()(editor.getData());
                    document.dispatchEvent(new CustomEvent('changelog_editor_onchange'));
                }, 1000));
                editor.ui.focusTracker.on('change:isFocused', (evt, name, isFocused) => {
                    if (!isFocused) {
                        valueAccessor()(editor.getData());
                        document.dispatchEvent(new CustomEvent('changelog_editor_onchange'));
                    }
                });

                editor.plugins.get('ImageUploadEditing').on('uploadComplete', (evt, { data, imageElement }) => {
                    editor.model.change(writer => {
                        writer.setAttribute('dataReference', data.reference, imageElement);
                    });
                });

                editor.model.schema.extend('imageBlock', { allowAttributes: 'dataReference' });

                editor.conversion.for('upcast').attributeToAttribute({
                    view: 'data-reference',
                    model: 'dataReference'
                });

                editor.conversion.for('downcast').add(dispatcher => {
                    dispatcher.on('attribute:dataReference:imageBlock', (evt, data, conversionApi) => {
                        if (!conversionApi.consumable.consume(data.item, evt.name)) {
                            return;
                        }

                        const viewWriter = conversionApi.writer;
                        const figure = conversionApi.mapper.toViewElement(data.item);
                        const img = figure.getChild(0);

                        if (data.attributeNewValue !== null) {
                            viewWriter.setAttribute('data-reference', data.attributeNewValue, img);
                        } else {
                            viewWriter.removeAttribute('data-reference', img);
                        }
                    });
                });
            })
            .catch(error => {
                console.error(error);
            });

        const h = (e) => {
            editorRef.current.setData(ko.unwrap(e.detail.content) || '');
        };
        document.addEventListener('tiny_should_change', h);
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            console.log('remov');
            document.removeEventListener('tiny_should_change', h);
            editorRef.current && editorRef.current.destroy();
        });
    },
    update: function (element, valueAccessor) {
    }
};

const project = window.auth.project;

class MyUploadAdapter {
    constructor(loader) {
        // The file loader instance to use during the upload.
        this.loader = loader;
    }

    // Starts the upload process.
    upload() {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                this._initRequest();
                this._initListeners(resolve, reject, file);
                this._sendRequest(file);
            }));
    }

    // Aborts the upload process.
    abort() {
        if (this.xhr) {
            this.xhr.abort();
        }
    }

    // Initializes the XMLHttpRequest object using the URL passed to the constructor.
    _initRequest() {
        const xhr = this.xhr = new XMLHttpRequest();

        // Note that your request may look different. It is up to you and your editor
        // integration to choose the right communication channel. This example uses
        // a POST request with JSON as a data structure but your configuration
        // could be different.
        xhr.open('POST', '/files/' + project.UniqueCode, true);
        xhr.responseType = 'json';
    }

    // Initializes XMLHttpRequest listeners.
    _initListeners(resolve, reject, file) {
        const xhr = this.xhr;
        const loader = this.loader;
        const genericErrorText = `Couldn't upload file: ${file.name}.`;

        xhr.addEventListener('error', () => reject(genericErrorText));
        xhr.addEventListener('abort', () => reject());
        xhr.addEventListener('load', () => {
            const response = xhr.response;

            // This example assumes the XHR server's "response" object will come with
            // an "error" which has its own "message" that can be passed to reject()
            // in the upload promise.
            //
            // Your integration may handle upload errors in a different way so make sure
            // it is done properly. The reject() function must be called when the upload fails.
            if (!response || response.error) {
                return reject(response && response.error ? response.error.message : genericErrorText);
            }

            // If the upload is successful, resolve the upload promise with an object containing
            // at least the "default" URL, pointing to the image on the server.
            // This URL will be used to display the image in the content. Learn more in the
            // UploadAdapter#upload documentation.
            resolve({
                default: 'https://cdn-assets.productfruits.com/' + response.fileId
            });
        });

        // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
        // properties which are used e.g. to display the upload progress bar in the editor
        // user interface.
        if (xhr.upload) {
            xhr.upload.addEventListener('progress', evt => {
                if (evt.lengthComputable) {
                    loader.uploadTotal = evt.total;
                    loader.uploaded = evt.loaded;
                }
            });
        }
    }

    // Prepares the data and sends the request.
    _sendRequest(file) {
        // Prepare the form data.
        const data = new FormData();

        data.append('file', file);

        // Important note: This is the right place to implement security mechanisms
        // like authentication and CSRF protection. For instance, you can use
        // XMLHttpRequest.setRequestHeader() to set the request headers containing
        // the CSRF token generated earlier by your application.

        // Send the request.
        this.xhr.send(data);
    }
}

// ...

function MyCustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        // Configure the URL to the upload script in your back-end here!
        return new MyUploadAdapter(loader);
    };
}
